import React, { useState } from "react";
import NavItems from "./NavItems";
import { AiOutlineMenu } from "react-icons/ai";
import { Link } from 'react-router-dom';


function Header() {
  const [togglemenu, setToggleMenu] = useState(false);
  return (
    <div className="bg-blue-300 w-full">
      <div className="flex mx-auto items-center py-3 px-4 justify-between max-w-[1250px] ">
        <div>
          <h1 className="text-2xl md:text-3xl font-semibold uppercase">
            <Link to={'/'}>
              webo solutions
            </Link>
          </h1>
        </div>
        <div>
          <NavItems menuToggle={togglemenu} />
          <AiOutlineMenu
            onClick={() => setToggleMenu(!togglemenu)}
            className="md:hidden cursor-pointer"
          />
        </div>
      </div>
    </div>
  );
}

export default Header;
